import React from 'react';
import RadioCheckPNG from '@/assets/images/radio-check.png';
import RadioNormalPNG from '@/assets/images/radio-normal.png';
import RadioHoverPNG from '@/assets/images/radio-hover.png';

// 未选中图标
const RadioButtonUnchecked = () => (
  <span
    className='radio-unchecked'
    style={{
      display: 'inline-block',
      width: '20px',
      height: '20px',
      background: `url("${RadioNormalPNG.src}") no-repeat center/contain`,
    }}
  />
);

// 选中图标
const RadioButtonChecked = () => (
  <span
    className='radio-checked'
    style={{
      display: 'inline-block',
      width: '20px',
      height: '20px',
      background: `url("${RadioCheckPNG.src}") no-repeat center/contain`,
    }}
  />
);

const MuiRadio = {
  styleOverrides: {
    root: {
      padding: '8px',
      '&.Mui-disabled': {
        opacity: 0.5,
      },
      // hover 样式
      '&:hover:not(.Mui-disabled):not(.Mui-checked)': {
        '& .radio-unchecked': {
          backgroundImage: `url("${RadioHoverPNG.src}") !important`,
          backgroundRepeat: 'no-repeat !important',
          backgroundPosition: 'center !important',
          backgroundSize: 'contain !important',
        },
      },
    },
  },
  defaultProps: {
    icon: React.createElement(RadioButtonUnchecked),
    checkedIcon: React.createElement(RadioButtonChecked),
  },
};

export default MuiRadio;
